import { StatisticsAnalysisGeneralStatisticsTrackingItems } from '@/modules/statistical-analysis-module/views/general-statistics-dossier/general-statistics-dossier.model'
import { Vue, Component, Prop, Emit } from 'vue-property-decorator'

@Component
export default class StatisticalAnalysisStatusLine extends Vue {
    @Prop() readonly trackingItems!: StatisticsAnalysisGeneralStatisticsTrackingItems[]

    @Emit()
    statusSelection(state: StatisticsAnalysisGeneralStatisticsTrackingItems): StatisticsAnalysisGeneralStatisticsTrackingItems {
        return state
    }

    onClick(state: StatisticsAnalysisGeneralStatisticsTrackingItems): void {
        this.statusSelection(state)
    }
}
